import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useAsyncInitialization } from 'hooks/useAsyncInitialization'
import { setUser } from 'redux/reducers/users'
import { setClaimsEmsnPreferences } from 'redux/reducers/claims'
import { medicareApiClient } from 'clients/medicareApiClient'

export function useFetchFullUser (): 'loading' | 'error' | 'finished' {
  const dispatch = useDispatch()
  const init = useCallback(async () => {
    // TODO: Once given the go ahead, revert to fetching user eMSN preferences via fetchFullUser, and remove the separate call to getMsnPreferences
    // dispatch(fetchFullUser([BeneficiaryModelOptions.E_MSN_PREFERENCES]))

    // We aren't using dispatch here so errors will be captured and allow an 'error' state.
    // That said, it turns out we don't care of errors are thrown here.
    // If user fails to load, they'll be redirect to /error
    // If emsn preferences fails to load we'll default.
    // Going to leave this as-is however, in case we make future requirements updates.
    const user = await medicareApiClient.asyncGetBeneficiaryFullData()
    if (user) {
      dispatch(setUser(user))
    } else {
      throw new Error('Error retrieving user')
    }

    const eMsnPreferences = await medicareApiClient.asyncGetEMSNPreference()
    if (eMsnPreferences) {
      dispatch(setClaimsEmsnPreferences(eMsnPreferences))
    } else {
      throw new Error('Error retrieving eMsn Preferences')
    }
  }, [dispatch])
  const loadingState = useAsyncInitialization(init)
  return loadingState
}
